import React, { useEffect, useState } from "react";
import { VehicleInfoItem } from "./vehicleInfoItem";
import { fetchBusClassification, fetchServiceProviderWithCity } from "../../../../../services/vehicleMasterService";
import { fetchRoutesData } from "../../../../../services/regionService";
import { generateLabelForRoute } from '../create/util';
import PropTypes from "prop-types";

function extractData(info, colCompare, fieldCompare) {
  if (info.status !== 'fulfilled' || !info.value?.length) {
    return null;
  }
  return info.value.find(i => i[colCompare] == fieldCompare);
}

export const VehicleDetailView = (props) => {
  const [data, setData] = useState(props.data);
  const [routeNameCorrespondeToRouteId, setRouteNameCorrespondeToRouteId] = useState('');

  const getRouteNames = (routes, allRoutes) =>
  routes.map((r) => {
    const found = allRoutes.find((route) => route.route_id == r.routeId);
    return found ? generateLabelForRoute(found) : r.routeId;
  });

  useEffect(() => {
    async function fetchAndSetData() {
      const { cityMaster, serviceCategory, serviceProvider, agency } = props.data;
      const agencyName = agency.name;

      const [busClassificationResult, serviceProviderResult, routesResult] = await Promise.allSettled([
        fetchBusClassification({ agencyName, cityId: cityMaster.id }),
        fetchServiceProviderWithCity({ agencyName, cityId: cityMaster.id }),
        fetchRoutesData(cityMaster.name, agencyName)
      ]);

      let updateData = { ...data };

      // service category name
      const serverServiceCategory = extractData(busClassificationResult, 'serviceId', serviceCategory);
      if (serverServiceCategory) {
        updateData.serviceCategory = serverServiceCategory.serviceName;
      }

      // service provider name
      const serverServiceProvider = extractData(serviceProviderResult, 'serviceProviderId', serviceProvider);
      if (serverServiceProvider) {
        updateData.serviceProvider = serverServiceProvider.serviceProviderName;
      }

      // route name from routeId
      const routeId = data.vehicleDispatchConfigDto?.routeId;
      const routes = data.vehicleDispatchConfigDto?.routes;

      if (routeId && routesResult.status === 'fulfilled' && routesResult.value) {
        const routeIdObj = routesResult.value.find(r => r.route_id == routeId);
        if (routeIdObj) {
          setRouteNameCorrespondeToRouteId(generateLabelForRoute(routeIdObj));
        }
        if (routes?.length) {
          updateData.vehicleDispatchConfigDto.routesWithName = getRouteNames(
            routes,
            routesResult.value
          );
        }

      }

      // vehicle seating layout
      if (data.vehicleSeatingLayoutDto?.name && data.vehicleSeatingLayoutDto?.layoutId) {
        updateData.vehicleSeatingLayoutDto =
          `${data.vehicleSeatingLayoutDto.name}[${data.vehicleSeatingLayoutDto.layoutId}]`;
      }

      setData(updateData);
    }
    fetchAndSetData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="row vehicle-info">
      <div className="col-sm-12">
        {Object.keys(data).map(columnKey => (
          <VehicleInfoItem
            key={columnKey}
            label={columnKey}
            value={data[columnKey]}
            routeNameCorrespondeToRouteId={routeNameCorrespondeToRouteId}
          />
        ))}
      </div>
    </div>
  );
};

VehicleDetailView.propTypes = {
  data: PropTypes.object,
};
